import React, { useEffect, useState } from "react";
import { CreditCard } from "lucide-react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
});

const cardCls =
  "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const disabledBtn =
  "inline-flex items-center gap-2 bg-white/5 border border-white/10 text-white/40 px-4 py-2 " +
  "rounded-lg cursor-not-allowed";

export default function SuperadminBilling() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/api/onboarding/orgs`, { headers: authHeaders() })
      .then((r) => r.ok ? r.json() : [])
      .then((data) => setOrgs(Array.isArray(data) ? data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-white">Billing & Subscriptions</h2>
        <p className="text-sm text-white/50 mt-1">
          Stripe integration coming soon.
        </p>
      </div>

      <div className="flex items-center gap-3">
        <button className={disabledBtn} disabled>
          <CreditCard size={16} /> Set up Stripe
        </button>
        <span className="text-xs text-white/40">Disabled until billing backend is wired.</span>
      </div>

      <div className={`${cardCls} overflow-hidden`}>
        {loading ? (
          <div className="p-8 text-center text-white/50">Loading…</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-white/5 text-white/60 text-xs uppercase">
                <tr>
                  <th className="text-left px-5 py-3">Organisation</th>
                  <th className="text-left px-5 py-3">Plan</th>
                  <th className="text-left px-5 py-3">Seats</th>
                  <th className="text-left px-5 py-3">Monthly Revenue</th>
                  <th className="text-left px-5 py-3">Status</th>
                  <th className="text-right px-5 py-3">Actions</th>
                </tr>
              </thead>
              <tbody>
                {orgs.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="p-8 text-center text-white/50">
                      No organisations yet.
                    </td>
                  </tr>
                ) : orgs.map((o) => (
                  <tr key={o.id} className="border-t border-white/5">
                    <td className="px-5 py-3 text-white">{o.name || o.slug || "—"}</td>
                    <td className="px-5 py-3 text-white/40">—</td>
                    <td className="px-5 py-3 text-white/40">—</td>
                    <td className="px-5 py-3 text-white/40">—</td>
                    <td className="px-5 py-3 text-white/40">—</td>
                    <td className="px-5 py-3 text-right text-white/40">—</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
